import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { ROUTES } from "./constants";
import { isHospitalPatientListUser } from "./patientListUserType";

type HmoAuthorityRouteProps = {
  children: React.ReactNode;
};

/**
 * Restricts access to non-hospital HMO authority users (admin, CPD, CMD, etc.).
 */
const HmoAuthorityRoute: React.FC<HmoAuthorityRouteProps> = ({ children }) => {
  const { auth } = useSelector((state: RootState) => state);

  if (isHospitalPatientListUser(auth)) {
    return <Navigate to={ROUTES.PATIENT_LIST} replace />;
  }

  return <>{children}</>;
};

export default HmoAuthorityRoute;
